/* unplugin-vue-components disabled */
import {Later} from 'utils/timers'

export default {
  props: {
    width: {
      type: String,
      default: '21.2rem'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minlength: {
      type: Number,
      default: 3
    },
    alwaysShow: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Search here ...'
    },
    delay: {
      type: Number,
      default: 800
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['search'],
  data() {
    return {
      show: false,
      search: '',
      do_search: $utils.timers.debounce(this.makeSearch, this.delay),
      do_blur: $utils.timers.debounce(this.onBlur, 1000),
      expand: new Later(500),
    }
  },
  computed: {
    c_show: {
      get() {
        return this.alwaysShow ? true : this.show
      },
      set(val) {
        if (this.alwaysShow) return
        this.show = val
      }
    },
    tr_search() {
      return this.search?.trim() || ''
    },
  },
  watch: {
    tr_search() {
      this.do_search()
    },
    loading(){
      if (this.loading) this.blur()
      else this.focus()
    }
  },
  beforeUnmount() {
    this.do_search.abort()
    this.do_blur.abort()
    this.expand.abort()
  },
  methods: {
    async makeSearch(){
      if (this.tr_search.length > 0 && this.tr_search.length < this.minlength) return
      this.$emit('search', this.tr_search)
    },
    onBlur(){
      if (this.$refs.search?.isFocused() || this.disabled || this.tr_search) return
      this.show = false
    },
    focus(){
      this.$refs.search?.focus()
    },
    blur(){
      this.$refs.search?.blur()
    },
    clearSearch(){
      this.search = ''
    },
    onClean(){
      this.clearSearch()
      this.focus()
    },
    onMouseEnter(){
      this.expand.abort()
      this.c_show = true
    },
    onMouseLeave(){
      if (this.tr_search.length) return
      this.expand.once(() =>  {
        if (!this.$refs.search?.isFocused()) this.c_show = false
      })
     
    }
  }
}
